import { ColumnDatasource } from '@/shared/resources/datasources/column-datasource'
import {
    CommonFilterModel,
    CommonPaginatorResourceService,
    CommonParams
} from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

export class PaginatorDatasource<T> extends ColumnDatasource<T> {
    readonly service: CommonPaginatorResourceService<T>

    constructor(service: CommonPaginatorResourceService<T>) {
        super()
        this.service = service
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        return this.service.paginator(filterModel, params)
    }
}
